import { render, staticRenderFns } from "./CreateWiki.vue?vue&type=template&id=288440d2&"
import script from "./CreateWiki.vue?vue&type=script&lang=js&"
export * from "./CreateWiki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports